<div class="certificate-details flex flex-col gap-6">
  <div class="flex flex-col gap-4">
    <div [formGroup]="metaDataForm()">
      <albert-input-wrapper controlName="member"
                            data-test="wrapper-certificate-details-member"
                            tooltipLabel="Insured"
                            [disabled]="!canEdit() || !!form().controls.certificateIdValue.value?.certificateId"
      >
        <p-iftalabel class="w-full">
          <p-autocomplete class="w-full"
                          data-test="certificate-details-member-select"
                          inputId="memberId"
                          optionLabel="name"
                          [disabled]="!canEdit() || !!form().controls.certificateIdValue.value?.certificateId"
                          [dropdown]="true"
                          [forceSelection]="true"
                          [invalid]="metaDataForm().controls.member.invalid && (metaDataForm().controls.member.dirty || metaDataForm().controls.member.touched)"
                          [minQueryLength]="3"
                          [ngModelOptions]="{ standalone: true }"
                          [ngModel]="selectedInsured()"
                          [required]="true"
                          [suggestions]="parentCompanies()"
                          (completeMethod)="onInsuredSearch($event)"
                          (onClear)="onInsuredClear()"
                          (onSelect)="onInsuredSelect($event)"
          />
          <label class="block font-medium mb-1"
                 for="memberId"
          >Insured</label>
        </p-iftalabel>
      </albert-input-wrapper>
    </div>
    @if (!selectedInsured()) {
      <small class="block text-red-500 text-xs -mt-3">Insured is required.</small>
    }
    <div *albertIfCategory="'associatedCompanies'; config: visibility"
         class="field-group h-full"
         [formGroup]="form()"
    >
      <albert-checkbox controlName="associatedCompanies"
                       data-test="certificate-details-include-associated-affiliated-subsidiary-companies"
                       groupName="associatedCompanies"
                       inputId="associatedCompanies"
                       label="Include associated, affiliated and subsidiary companies of Insured"
                       [disabled]="!canEdit()"
      />
    </div>
    <div *albertIfCategory="'periodId'; config: visibility"
         [formGroup]="periodForm()"
    >
      <albert-input-wrapper controlName="uuid"
                            data-test="wrapper-period"
                            tooltipLabel="Period"
                            [disabled]="!canEdit()"
      >
        <albert-select controlName="uuid"
                       data-test="certificate-details-period-select'"
                       inputId="uuid"
                       label="Period"
                       [disabled]="!canEdit()"
                       [options]="periodOptions() ?? []"
                       [required]="true"
        />
      </albert-input-wrapper>
    </div>
    <div *albertIfCategory="'policyId'; config: visibility"
         [formGroup]="policyForm()"
    >
      <albert-input-wrapper controlName="uuid"
                            data-test="wrapper-policy"
                            tooltipLabel="Proposal"
                            [disabled]="!canEdit() || (policyOptions() ? policyOptions()?.length === 1 : false)"
      >
        <albert-select controlName="uuid"
                       data-test="certificate-details-proposal-select"
                       inputId="uuid"
                       label="Proposal"
                       [disabled]="!canEdit() || policyOptions() ? policyOptions()?.length === 1 : false"
                       [options]="policyOptions() ?? []"
                       [required]="true"
        />
      </albert-input-wrapper>
    </div>
  </div>

  <div class="comparison-grid expanded-mode"
       data-test="certificate-details-comparison-grid-0"
  >
    <div>
      <p-table data-test="certificate-details-table-left"
               [value]="leftTableData()"
      >
        <ng-template #body
                     let-row
        >
          <tr>
            <td class="font-bold">{{ row.label }}</td>
            <td>{{ row.value ?? '-' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="override-cell">
      <p-table data-test="certificate-details-table-right"
               [value]="rightTableData()"
      >
        <ng-template #body
                     let-row
        >
          <tr>
            <td class="font-bold">{{ row.label }}</td>
            <td>{{ row.value ?? '-' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>

  <div class="comparison-grid expanded-mode"
       data-test="certificate-details-comparison-grid-1"
       [formGroup]="form()"
  >
    <div *albertIfCategory="'linkedCertificates'; config: visibility">
      <albert-input-wrapper controlName="linkedCertificates"
                            data-test="wrapper-certificate-linked-certs"
                            tooltipLabel="Linked Certificates"
                            [disabled]="!canEdit()"
      >
        <albert-select controlName="linkedCertificates"
                       inputId="linkedCertificates"
                       label="Linked Certificates"
                       [attr.data-test]="'certificate-linked-certs'"
                       [disabled]="!canEdit()"
                       [options]="[]"
        />
      </albert-input-wrapper>
    </div>
    @if (categoryService.activeCertificateCategory() !== CertificateCategory.LSG) {
      <div *albertIfCategory="'certificateAuthor'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper controlName="certificateAuthor"
                              data-test="wrapper-certificate-author"
                              tooltipLabel="Certificate Author"
                              [disabled]="!canEdit()"
        >
          <albert-select controlName="certificateAuthor"
                         inputId="certificateAuthor"
                         label="Certificate Author"
                         [attr.data-test]="'certificate-author'"
                         [disabled]="!canEdit()"
                         [options]="certificateAuthorOptions"
                         [required]="true"
          />
        </albert-input-wrapper>
      </div>
    }
  </div>

  <div *albertIfCategory="'title'; config: visibility"
       data-test="certificate-details-title"
       [formGroup]="form()"
  >
    <albert-input-wrapper data-test="wrapper-certificate-title"
                          groupName="title"
                          tooltipLabel="Certificate Title"
                          [disabled]="!canEdit()"
    >
      <albert-input controlName="title"
                    data-test="certificate-title"
                    groupName="title"
                    inputId="title"
                    label="Certificate Title"
                    [disabled]="!canEdit()"
      />
    </albert-input-wrapper>
  </div>
  <div class="comparison-grid expanded-mode"
       data-test="certificate-details-comparison-grid-2"
       [formGroup]="form()"
  >

    <div *albertIfCategory="'effectiveDate'; config: visibility">
      <albert-input-wrapper controlName="effectiveDate"
                            data-test="wrapper-certificate-effective-date"
                            tooltipLabel="Effective Date"
                            [disabled]="!canEdit()"
      >
        <albert-datepicker controlName="effectiveDate"
                           data-test="certificate-effective-date"
                           inputId="effectiveDate"
                           label="Effective Date"
                           [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>
    <div class="override-cell">

      @if (categoryService.activeCertificateCategory() === CertificateCategory.LSG) {
        <albert-input-wrapper *albertIfCategory="'certificateAuthor'; config: visibility"
                              controlName="certificateAuthor"
                              data-test="wrapper-certificate-author"
                              tooltipLabel="Certificate Author"
                              [disabled]="!canEdit()"
        >
          <albert-select controlName="certificateAuthor"
                         inputId="certificateAuthor"
                         label="Certificate Author"
                         [attr.data-test]="'certificate-author'"
                         [disabled]="!canEdit()"
                         [options]="certificateAuthorOptions"
                         [required]="true"
          />
        </albert-input-wrapper>
      }

      <albert-input-wrapper *albertIfCategory="'subjectToCertification'; config: visibility"
                            controlName="subjectToCertification"
                            data-test="wrapper-certificate-subject"
                            tooltipLabel="Subject to Certification"
                            [disabled]="!canEdit()"
      >
        <albert-select controlName="subjectToCertification"
                       inputId="subjectToCertification"
                       label="Subject to Certification"
                       [attr.data-test]="'certificate-subject-to-certification'"
                       [disabled]="!canEdit()"
                       [options]="subjectToCertificationOptions"
        />
      </albert-input-wrapper>
    </div>

    <div class="field-group h-full">
      <albert-checkbox *albertIfCategory="'notToBeRenewed'; config: visibility"
                       controlName="notToBeRenewed"
                       data-test="certificate-not-to-be-renewed"
                       groupName="notToBeRenewed"
                       inputId="notToBeRenewed"
                       label="Not to be renewed"
                       [disabled]="!canEdit()"
      />
    </div>

    <div class="override-cell">
      <albert-freetext-section *albertIfCategory="'subjectToCertificationFreetext'; config: visibility"
                               dataTestPrefix="certificate-details"
                               [form]="form()"
                               [section]="freetextSectionsByKey.subjectToCertificationFreetext"
      />
    </div>
  </div>

  <div *albertIfCategory="'authoritiesSpecialFormat'; config: visibility"
       class="flex flex-col gap-6"
       data-test="certificate-details-authorities-special-formats"
       [formGroup]="form()"
  >
    <albert-input-wrapper data-test="wrapper-authorities-special-formats"
                          groupName="authoritiesSpecialFormat"
                          tooltipLabel="Authorities Special Formats"
                          [disabled]="!canEdit()"
    >
      <albert-select controlName="authoritiesSpecialFormat"
                     data-test="certificate-authorities-special-formats"
                     inputId="authoritiesSpecialFormat"
                     label="Authorities Special Formats"
                     [disabled]="!canEdit()"
                     [options]="authoritiesSpecialFormatOptions"
      />
    </albert-input-wrapper>
  </div>

  <div *albertIfCategory="'status'; config: visibility"
       class="comparison-grid expanded-mode"
       data-test="certificate-details-comparison-grid-3"
       [formGroup]="form()"
  >
    <div class="field-group">
      <p-iftalabel class="w-full">
        <input class="w-full p-inputtext"
               data-test="certificate-status"
               id="status"
               pInputText
               type="text"
               [disabled]="true"
               [value]="statusLabel() ?? ''"
        />
        <label class="block font-medium mb-1"
               for="status"
        >Certificate Status</label>
      </p-iftalabel>
    </div>

    <div *albertIfCategory="'documentStatus'; config: visibility"
         class="override-cell field-group"
    >
      <p-iftalabel class="w-full">
        <input class="w-full p-inputtext"
               data-test="certificate-document-status"
               id="documentStatus"
               pInputText
               type="text"
               [disabled]="true"
               [value]="documentStatusLabel() ?? ''"
        />
        <label class="block font-medium mb-1"
               for="documentStatus"
        >Document Status</label>
      </p-iftalabel>
    </div>
  </div>
</div>
